var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner flex",class:_vm.size},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }